'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'bus';
var width = 448;
var height = 512;
var aliases = [128653];
var unicode = 'f207';
var svgPathData = 'M96 16l256 0c44.2 0 80 35.8 80 80L16 96c0-44.2 35.8-80 80-80zM16 112l200 0 0 160-200 0 0-160zM432 272l-200 0 0-160 200 0 0 160zM16 288l416 0 0 96c0 26.5-21.5 48-48 48L64 432c-26.5 0-48-21.5-48-48l0-96zM128 448l192 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-40.6c19.1-11.1 32-31.7 32-55.4l0-288c0-53-43-96-96-96L96 0C43 0 0 43 0 96L0 384c0 23.7 12.9 44.4 32 55.4L32 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32zm-16 0l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-34c5.1 1.3 10.5 2 16 2l48 0zm224 32l0-32 48 0c5.5 0 10.9-.7 16-2l0 34c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM96 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm240-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM168 48c-4.4 0-8 3.6-8 8s3.6 8 8 8l112 0c4.4 0 8-3.6 8-8s-3.6-8-8-8L168 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;